<template>
  <div class="page">
    <Header title="首页" />
    <div style="padding: 20px; line-height: 24px">
      <div>This is a temporary home view.</div>
      <div>
        <a href="https://wx.bosch-extra.com.cn"
          >You may click here back to eXtra wechat site</a
        >
      </div>
      <!-- <div>
        <router-link to="/gallery/category">View Gallery Module</router-link>
      </div>
      <div>
        <router-link to="/course/category">View Course Module</router-link>
      </div>
      <div>
        <router-link to="/activity/sign521">View Sign521 Page</router-link>
      </div>
      <div>
        <router-link to="/activity/qr-sign/36">扫码签到活动</router-link>
      </div>
      <div>
        <router-link to="/activity/dragon-boat">View Dragon Boat Page</router-link>
      </div>
      <div>
        <router-link to="/activity/team-pk">View Team PK</router-link>
      </div>
      <div>
        <router-link to="/questionnaire/2020">问卷调查</router-link>
      </div>
      <div>
        <router-link to="/activity/new-year-gift">新年礼包</router-link>
      </div>
      <div>
        <router-link to="/activity/activity-thanks-letter">感谢信</router-link>
      </div>
      <div>
        <router-link to="/lottery/home">大乐透</router-link>
      </div>
      <div>
        <router-link to="/activity/red-packet-rain">红包雨</router-link>
      </div>
      <div>
        <router-link to="/extra-style">易加faner</router-link>
      </div>
      <div>
        <router-link to="/activity/kt-renewed">KT换新</router-link>
      </div>
      <div>
        <router-link to="/activity/collect-cards">春游集卡</router-link>
      </div>
      <div>
        <router-link to="/activity/streaming-verification">表单验证</router-link>
      </div>
      <div>
        <router-link to="/activity/activity-turntable">8周年轮盘</router-link>
      </div>
      <div>
        <router-link to="/activity/live-broadcast-register">直播活动</router-link>
      </div>
      <div>
        <router-link to="/subordinate/management">下级管理</router-link>
      </div>
      <div>
        <router-link to="/activity/dreaming">梦想地图</router-link>
      </div>
      <div>
        <router-link to="/activity/seckill">秒杀</router-link>
      </div>
      <div>
        <router-link to="/activity/theX-video">theX video</router-link>
      </div>
      <div>
        <router-link to="/activity/activity-video">视频投票</router-link>
      </div>
      <div>
        <router-link to="/activity/double-eleven-2020">2020双十一</router-link>
      </div>
      <div>
        <router-link to="/activity/thanks-letter-cover-2020">2020感谢信</router-link>
      </div>

      <div>
        <router-link to="/activity/activity-video">视频投票</router-link>
      </div>

      <div>
        <router-link to="/activity/new-year-draw-2021">2021新年活动</router-link>
      </div> -->
      <div>
        <router-link to="/activity/refuel">一起来加油</router-link>
      </div>
      <div>
        <router-link to="/center-qrcode/my-qrcode">我的二维码</router-link>
      </div>
      <div>
        <router-link to="/activity/activity-workshop-collect">WorkShop</router-link>
      </div>
      <div>
        <router-link to="/activity/2022/scan-first-half">2022扫码</router-link>
      </div>
      <div>
        <router-link to="/login">登录</router-link>
      </div>
      <div>
        <router-link to="/plain/qrCode/scan">扫码</router-link>
      </div>
      <div>
        <router-link to="/quality-assurance-ws">电子质保</router-link>
      </div>
      <div>
        <router-link to="/activity/2021/activity-booth">线下活动</router-link>
      </div>
      <div>
        <router-link to="/activity/2022/activity-2022-scan">测试</router-link>
        <!-- <router-link to="/activity/red-packet-rain">测试</router-link>    -->
      </div>
      <div>
        <router-link to="/activity/2022/activity-star-pick">摘星测试</router-link>
      </div>
      <div>
        <router-link to="/activity/2022/activity-wiper-video">雨刮视频测试</router-link>
      </div>
      <div>
        <router-link to="/activity/2023/activity-cards">易卡送福利测试</router-link>
      </div>
      <div>
        <router-link to="/login2">登录2*new</router-link>
      </div>

    </div>
  </div>
</template>

<script>
import Header from '@/components/header'
export default {
  name: 'Home',
  components: {
    Header
  },
  created () {
    // window.location.href = 'https://wx.bosch-extra.com.cn'
  },
  methods: {
    headerLeftEvent () {
      console.log('hello from home')
    }
  }
}
</script>

<style></style>
